export const LIB_PLAYER = {
    PLYR: 1,
    BRID_PLAYER: 2,
    VIDEO_JS: 3,
};
export const VIDEO_TYPE = {
    VOD: 0,
    LIVE: 1,
};
export const PLAYER_LOCATION = {
    VIEWMEDIA: 0,
    LIVESTREAMING: 1,
    EMBED: 2,
    ADV_REWARD_FOR_COIN: 3,
};
export const ADS_ROLL_TYPE = {
    PRE_ROLL: 0,
    MID_ROLL: 1,
    POST_ROLL: 2,
};
export const ADS_ROLL_TYPE_BRID = {
    PRE_ROLL_BRID: 0,
    MID_ROLL_BRID: 1,
    POST_ROLL_BRID: 2,
};
export const ADS_TIME = 15;
export const ADS_WATCHED = 1;
export const ADS_NOT_WATCHED = 0;
/* -------------------------------------------------------------------------- */
/*                                     ADS                                    */
/* -------------------------------------------------------------------------- */
export const Time_Sleep_Restart_Before_Call_Check = 5000;
export const Time_Sleep_Restart_After_Error = 2000;
export const Time_Sleep_Restart_Standard = 2000;
export const Time_Analytics_Sender_Interval = 10000;
export const ANALYTICS_GO_URL = "https://video-analytics.babyloncloud.com/add";
export const WEB_SOCKET_URL = "ws.babylonvid.com";
//numero minimo di analitiche prima dell'invio
export const MIN_VALUE_TO_SEND = 50;
//attiva le analitiche
export const NEED_ANALYTICS = true;
// Se true, può fare la chiamata diretta a DB per avere lo status della tabellare
// Se false, si basa con script GO
export const CAN_CALL_ADS_PLAYING_DB = false;
// Variabile necessaria per attivare controllo GDPR nell'avvio del player
export const NEED_GDPR_CONTROL = true;
